import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 64px 0;
`;

const MarketingBox = styled.div`
  display: flex;
  background-color: #f7f7f5;
  border: 1px solid #d9d9d9;
  border-radius: 12px;
  padding: 32px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;
`;

const TextBlock = styled.div`
  max-width: 500px;

  h3 {
    font-size: 22px;
    margin-bottom: 12px;
  }

  p {
    font-size: 14px;
    color: #666;
    margin-bottom: 16px;
  }

  button {
    background-color: #111827;
    color: white;
    border: none;
    padding: 10px 18px;
    border-radius: 6px;
    cursor: pointer;
  }
`;

const Image = styled.img`
  max-height: 160px;
  object-fit: contain;
  flex-shrink: 0;
`;

const PressSection = styled.div`
  margin-top: 64px;

  h4 {
    font-size: 18px;
    margin-bottom: 16px;
  }

  .logos {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 24px;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 40px;
      object-fit: contain;
      filter: grayscale(100%);
    }
  }

  a {
    display: inline-block;
    margin-top: 12px;
    font-size: 14px;
    color: #444;
    text-decoration: underline;
  }
`;

const MarketingAndPress = () => {
  return (
    <Wrapper>
      <MarketingBox>
        <TextBlock>
          <h3>Marketing solutions for our partners big and small</h3>
          <p>
            Whether you are a property owner, manager, or broker, we offer
            customized solutions to help you reach millions of quality renters
            during every step of the renter journey.
          </p>
          <button>List your property</button>
        </TextBlock>
        <Image
          src="https://images.rawpixel.com/image_png_800/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvcHg1NjkzMjEtaW1hZ2VfMS1renAycXhwOC5wbmc.png"
          alt="Marketing Illustration"
        />
      </MarketingBox>

      <PressSection>
        <h4>Find us in the press</h4>
        <div className="logos">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQKevRMU1nThKzQXezoJPJeZtPnCUrOf8aWbw&s"
            alt="New York Times"
          />
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ-whKi21YaishuL6G4pmQagJsrq2nCKYiuwA&s"
            alt="Forbes"
          />
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTDmNMZTLPHLCifZr3eG56RAAkYxtoJl1xQhw&s"
            alt="TechCrunch"
          />
          <img
            src="https://www.pngfind.com/pngs/m/679-6793891_wall-street-journal-logo-white-png-wsj-logo.png"
            alt="Wall Street Journal"
          />
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/b/bf/Washington_Post_favicon.png"
            alt="Washington Post"
          />
        </div>
      </PressSection>
    </Wrapper>
  );
};

export default MarketingAndPress;
